import { render, staticRenderFns } from "./asignar-director.vue?vue&type=template&id=92cb249e"
import script from "./asignar-director.vue?vue&type=script&lang=js"
export * from "./asignar-director.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports